import { ConsentPreferences } from "./types";

const deleteCookie = (name: string) => {
  const domains = [window.location.hostname, `.${window.location.hostname}`];
  const parts = window.location.hostname.split(".");

  for (let index = 0; index < parts.length - 1; index += 1) {
    domains.push(`.${parts.slice(index).join(".")}`);
  }

  const uniqueDomains = Array.from(new Set(domains));

  uniqueDomains.forEach((domain) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}; SameSite=Lax`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}; SameSite=None; Secure`;
  });

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=None; Secure`;
};

const deleteCookiesByPrefix = (prefixes: string[]) => {
  const cookieNames = document.cookie
    .split(";")
    .map((entry) => entry.trim().split("=")[0])
    .filter(Boolean);

  cookieNames.forEach((cookieName) => {
    if (prefixes.some((prefix) => cookieName === prefix || cookieName.startsWith(prefix))) {
      deleteCookie(cookieName);
    }
  });
};

export const applyConsentServices = (preferences: ConsentPreferences) => {
  if (!preferences.external_media) {
    // Remove common media/embed cookies when consent is withdrawn.
    deleteCookiesByPrefix(["VISITOR_INFO1_LIVE", "YSC", "PREF"]);
  }
};

export const clearOptionalCookies = (preferences: ConsentPreferences) => {
  if (!preferences.external_media) {
    deleteCookiesByPrefix(["VISITOR_INFO1_LIVE", "YSC", "PREF"]);
  }
};
